<template>
  <header class="Header el-header">
    <img src="../../assets/logo.png" alt="证书查询-logo" class="header-log">
    <div class="rightinfo">
      <el-dropdown class="stae">
        <span class="el-dropdown-link">
          <i class="el-icon-success" style="margin-right: 15px"></i>
          欢迎您，管理员：admin
          <i class="el-icon-arrow-down el-icon-right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    logout (event) {
      this.$store.commit('REMOVE_COUNT')
      this.$message('退出登录!')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.el-header {
  height: 80px;
  background-color: #49d292;
  position: relative;
}
.el-header img {
  height: 48px;
  display: block;
  position: absolute;
  top: 50%;
  left: 7%;
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
}
.rightinfo {
  color: #fff;
  vertical-align: middle;
  line-height: 80px;
  cursor: pointer;
  float: right;
  font-size: 13px;
}
.el-tag--info > i {
  margin-right: 6px;
}
.el-dropdown.stae {
  color: #fff;
}
.el-dropdown-link {
  cursor: pointer;
}
</style>
